import { render, staticRenderFns } from "./Q2.vue?vue&type=template&id=7909c91e&"
import script from "./Q2.vue?vue&type=script&lang=ts&"
export * from "./Q2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports